import { Organization } from "./organization.model";
import { User } from "./user.model";

export class Classroom {
  constructor(
    public coursesIds: string[] = [],
    public id: string = "",
    public name: string = "",
    public disabled: boolean = false,
    public organization: Organization = new Organization(),
    public users: User[] = []
  ) {}
}
